import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { Person } from '@/models';
import { myLocalStorage } from '@/myLocalStorage';
import { getSignInRedirectUrl } from './routeUtils';

const SignInGuard: FC = () => {
  const me: Person | undefined = myLocalStorage.getItem('person');

  if (me?.id == null) {
    return <Navigate to={getSignInRedirectUrl()} replace />;
  }

  return <Outlet />;
};

export default SignInGuard;
